import { motion } from "framer-motion";
import * as COMMONS from "common/common";

const { div: Div } = motion;

/**
 * @param {Omit<import('react').ComponentProps<typeof motion['div']>, 'variants'>} props
 * @returns {JSX.Element}
 */
export default function MotionDiv({ children, ...rest }) {
	return (
		<Div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM} {...rest}>
			{children}
		</Div>
	);
}
